import { render } from "./Propertystatement.vue?vue&type=template&id=621b8fa5&scoped=true"
import script from "./Propertystatement.vue?vue&type=script&lang=js"
export * from "./Propertystatement.vue?vue&type=script&lang=js"

import "./Propertystatement.vue?vue&type=style&index=0&id=621b8fa5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621b8fa5"]])

export default __exports__